import React, { useState, useEffect } from 'react';
import axios from 'axios'
import qs from "qs";
import { useMutation } from "@apollo/react-hooks"
import { EXIST_ID } from '../../Queries/existId';
import Presenter from "./RedirectPresenter"
import { CREATE_ACCOUNT } from '../../Queries/createAccount';
import { GENERATE_TOKEN } from '../../Queries/generateToken';
import { LOCAL_LOGIN } from '../../Queries/localLogin';

export default () => {
    const [CreateAccountMutation] = useMutation(CREATE_ACCOUNT)
    const [ExistIdCheckMutation] = useMutation(EXIST_ID)
    const [existUser, setExistUser] = useState(0)
    const [userData, setUserData] = useState(null)
    const [generateToken] = useMutation(GENERATE_TOKEN)
    const [localLogInMutation] = useMutation(LOCAL_LOGIN);

    useEffect(() => {
        const queryParams = window.location.search;
        const urlParams = new URLSearchParams(queryParams);
        const url_code = decodeURI(urlParams.get('code'))
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const urls = `https://accounts.google.com/o/oauth2/token`
        // code 받음 and token 받을 준비
        axios.post(urls,
            qs.stringify({
                code: url_code,
                client_id: process.env.REACT_APP_CLIENTID,
                client_secret: process.env.REACT_APP_SECRET,
                redirect_uri: process.env.NODE_ENV === "development" ? "http://localhost:3000/redirect" : "https://www.thatgeul.com/redirect",
                grant_type: "authorization_code"
            }), config
        ).then(async (res) => {
            const token = res.data.access_token
            const url = `https://www.googleapis.com/youtube/v3/channels?part=snippet&mine=true&access_token=${token}`
            await axios.get(url).then(async (res) => {
                /**
                 * 1. channelId = res.data.items[0].id
                 * 2. channelName = res.data.items[0].snippet.title
                 * 3. thumbNail = res.data.itmes[0].snippet.thumbnails.default.url (height 88)
                 * 4. thumbnails.medium.url (height 240)
                 * 5. thumbnails.high.url (height 800)
                 */
                console.log(res)
                const existUser = await ExistIdCheckMutation({
                    variables: {
                        channelId: res.data.items[0].id
                    }
                })
                setExistUser(existUser.data.existId)
                setUserData(res.data)
                if (existUser.data.existId === true) {
                    const {data:{generateToken:token}} = await generateToken({
                        variables:{
                            channelId:res.data.items[0].id
                        }
                    })
                    if(token){
                          localLogInMutation({
                            variables: { token }
                        });
                        window.location.assign("/")
                    }
                }
            }).catch((err) => {
                console.log(err)
            })
        })
    }, [])
    const onSubmit = async (e) => {
        e.preventDefault();
        const user = await CreateAccountMutation({
            variables: {
                channelId: userData.items[0].id,
                displayName: userData.items[0].snippet.title,
                profileImageUrl: userData.items[0].snippet.thumbnails.default.url
            }
        })
        if (user) {
            /**
                * 1. cookie 생성,
                * 2. 쿠키저장 channelId와 sessionId 저장시키기 만료시간은 일주일로.
                * 3. 이동시키기 강제로.
            */
            // const userAccount = user.data.createAccount
            return window.location.assign("/")
        } else {
            alert("다시 가입해 주세요")
            return window.location.assign("/")
        }
    }
    

    return (
        <Presenter
            onSubmit={onSubmit}
            existUser={existUser}
            userData={userData}
        />
    )
}